import { render, staticRenderFns } from "./SchedulePaymentsSettingsList.vue?vue&type=template&id=d9315512"
import script from "./SchedulePaymentsSettingsList.vue?vue&type=script&lang=js"
export * from "./SchedulePaymentsSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports